<section class="page">
  <div class="container">
    <div class="page-wrapper">
      <div class="page-header">
        <h1 class="page-title">Adicionar empreendimento</h1>
        <div class="page-header__buttons">
          <button
            mat-stroked-button
            color="primary"
            routerLink="/imobiliaria/empreendimentos"
          >
            VOLTAR
          </button>
        </div>
      </div>
      <mat-vertical-stepper [linear]="false" #stepper class="page-form">
        <mat-step
          [stepControl]="immobileFormGroup"
          errorMessage="Preencha todos os campos requiridos."
        >
          <form [formGroup]="immobileFormGroup" class="wrapper">
            <ng-template matStepLabel>Dados do Imóvel</ng-template>
            <mat-form-field
              class="page-form-control"
              [class.two-third]="auth.user.tipo === 'C'"
            >
              <mat-label>Nome</mat-label>
              <input
                matInput
                placeholder="De um título para o imóvel"
                formControlName="nome"
                required
              />
            </mat-form-field>
            <mat-form-field
              class="page-form-control"
              [class.third]="auth.user.tipo === 'C'"
              [class.quad]="auth.user.tipo === 'A'"
            >
              <mat-label>Status</mat-label>
              <mat-select formControlName="status" required>
                <mat-option
                  *ngFor="let e of empreendimentoStatus"
                  [value]="e.value"
                  >{{ e.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              class="page-form-control third"
              *ngIf="auth.user.tipo === 'A'"
            >
              <mat-label>Entrar em contato</mat-label>
              <mat-select formControlName="entrarEmContato" required>
                <mat-option value="C">Corretor</mat-option>
                <mat-option value="I">Imobiliária</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              class="page-form-control third"
              *ngIf="auth.user.tipo === 'A'"
            >
              <mat-label>Corretor</mat-label>
              <mat-select formControlName="usuarioImobiliaria">
                <mat-option>
                  <ngx-mat-select-search
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="searchUsuariosImobiliaria"
                    name="searchUsuariosImobiliaria"
                    placeholderLabel="Pesquise aqui"
                    noEntriesFoundLabel="Nenhum registro encontrado"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="
                    let u of usuariosImobiliaria
                      | filter : searchUsuariosImobiliaria : 'nome'
                  "
                  [value]="u"
                >
                  {{ u.nome }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="page-form-control">
              <mat-label>Descrição</mat-label>
              <textarea
                matInput
                rows="6"
                placeholder="Descreva um pouco o imóvel"
                formControlName="descricao"
              ></textarea>
            </mat-form-field>
            <mat-form-field class="page-form-control">
              <mat-label>Diferenciais</mat-label>
              <textarea
                matInput
                rows="6"
                placeholder="Informe alguns de seus diferenciais"
                formControlName="diferenciais"
              ></textarea>
            </mat-form-field>
          </form>
        </mat-step>
        <mat-step
          [stepControl]="addressFormGroup"
          errorMessage="Preencha todos os campos requiridos."
        >
          <form [formGroup]="addressFormGroup" class="wrapper">
            <ng-template matStepLabel>Endereço</ng-template>
            <mat-form-field class="page-form-control">
              <mat-label>CEP</mat-label>
              <input
                matInput
                type="tel"
                placeholder="00000-000"
                formControlName="cep"
                mask="00000-000"
                (blur)="onBlurCep($event)"
                required
              />
              <mat-hint
                >Digite um cep aqui para buscarmos a localização exata do
                mapa</mat-hint
              >
            </mat-form-field>
            <mat-form-field class="page-form-control half">
              <mat-label>Estado</mat-label>
              <mat-select
                formControlName="uf"
                (selectionChange)="onChangeEstado($event)"
              >
                <mat-option>
                  <ngx-mat-select-search
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="searchEstados"
                    name="searchEstados"
                    placeholderLabel="Pesquise aqui"
                    noEntriesFoundLabel="Nenhum registro encontrado"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="
                    let e of estados | filter : searchEstados : 'descricao'
                  "
                  [value]="e.sigla"
                >
                  {{ e.descricao }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="page-form-control half">
              <mat-label>Cidade</mat-label>
              <mat-select formControlName="cidade">
                <mat-option>
                  <ngx-mat-select-search
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="searchCidades"
                    name="searchCidades"
                    placeholderLabel="Pesquise aqui"
                    noEntriesFoundLabel="Nenhum registro encontrado"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let c of cidades | filter : searchCidades : 'nome'"
                  [value]="c.nome"
                >
                  {{ c.nome }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="page-form-control half">
              <mat-label>Bairro</mat-label>
              <input matInput formControlName="bairro" required />
            </mat-form-field>
            <mat-form-field class="page-form-control half">
              <mat-label>Rua</mat-label>
              <input matInput formControlName="endereco" required />
            </mat-form-field>
            <mat-form-field class="page-form-control third">
              <mat-label>Número</mat-label>
              <input
                matInput
                type="tel"
                formControlName="numeroEndereco"
                #numeroEnderecoInput
                (blur)="onNumeroEnderecoBlur($event)"
              />
            </mat-form-field>
            <mat-form-field class="page-form-control two-third">
              <mat-label>Complemento</mat-label>
              <input matInput formControlName="complemento" />
            </mat-form-field>
            <div class="map-control">
              <div class="wrapper">
                <mat-form-field class="page-form-control half">
                  <mat-label>Latitude</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="latitude"
                    readonly
                    required
                  />
                </mat-form-field>
                <mat-form-field class="page-form-control half">
                  <mat-label>Longitude</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="longitude"
                    readonly
                    required
                  />
                </mat-form-field>
              </div>
              <app-im-map
                [lat]="addressFormGroup.get('latitude').value"
                [lng]="addressFormGroup.get('longitude').value"
                *ngIf="
                  addressFormGroup.get('latitude').value &&
                  addressFormGroup.get('longitude').value
                "
                (event)="getLatLng($event)"
              ></app-im-map>
            </div>
          </form>
        </mat-step>
        <mat-step
          [stepControl]="featuresFormGroup"
          errorMessage="Preencha todos os campos requiridos."
        >
          <form [formGroup]="featuresFormGroup" class="wrapper">
            <ng-template matStepLabel>Características</ng-template>
            <mat-form-field appearance="fill" class="page-form-control quad">
              <mat-label>Vagas de garagem</mat-label>
              <input
                matInput
                formControlName="numeroBoxGaragem"
                type="tel"
                mask="0*"
              />
              <i matPrefix class="fas fa-car icon-prefix"></i>
            </mat-form-field>
            <mat-form-field appearance="fill" class="page-form-control quad">
              <mat-label>Quartos</mat-label>
              <input
                matInput
                formControlName="numeroQuartos"
                type="tel"
                mask="0*"
              />
              <i matPrefix class="fas fa-bed icon-prefix"></i>
            </mat-form-field>
            <mat-form-field appearance="fill" class="page-form-control quad">
              <mat-label>Suítes</mat-label>
              <input
                matInput
                formControlName="numeroSuites"
                type="tel"
                mask="0*"
              />
              <i matPrefix class="fas fa-bath icon-prefix"></i>
            </mat-form-field>
            <mat-form-field appearance="fill" class="page-form-control quad">
              <mat-label>Banheiros</mat-label>
              <input
                matInput
                formControlName="numeroBanheiros"
                type="tel"
                mask="0*"
              />
              <i matPrefix class="fas fa-shower icon-prefix"></i>
            </mat-form-field>
            <mat-form-field appearance="fill" class="page-form-control quad">
              <mat-label>Terreno</mat-label>
              <input
                matInput
                formControlName="tamanhoTerrenoM2"
                type="tel"
                type="text"
                currencyMask
                [options]="{ prefix: '', thousands: '.', decimal: ',' }"
              />
              <i matPrefix class="fas fa-crop-alt icon-prefix"></i>
              <span matSuffix>m²</span>
            </mat-form-field>
            <mat-form-field appearance="fill" class="page-form-control quad">
              <mat-label>Área construída</mat-label>
              <input
                matInput
                formControlName="tamanhoAreaConstruidaM2"
                type="tel"
                currencyMask
                [options]="{ prefix: '', thousands: '.', decimal: ',' }"
              />
              <i matPrefix class="fas fa-object-group icon-prefix"></i>
              <span matSuffix>m²</span>
            </mat-form-field>
          </form>
        </mat-step>
        <mat-step
          [stepControl]="typeFormGroup"
          errorMessage="Preencha todos os campos requiridos."
        >
          <ng-template matStepLabel>Tipo</ng-template>
          <form [formGroup]="typeFormGroup" class="wrapper">
            <mat-form-field class="page-form-control quad">
              <mat-label>Tipo</mat-label>
              <mat-select
                formControlName="tipoEmpreendimento"
                (selectionChange)="onChangeTipoEmpreendimento($event)"
                required
              >
                <mat-option>
                  <ngx-mat-select-search
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="searchTiposEmpreendimento"
                    name="searchTiposEmpreendimento"
                    placeholderLabel="Pesquise aqui"
                    noEntriesFoundLabel="Nenhum registro encontrado"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="
                    let t of tiposEmpreendimento
                      | filter : searchTiposEmpreendimento : 'nome'
                  "
                  [value]="t"
                >
                  {{ t.nome }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="page-form-control quad">
              <mat-label>Subtipo</mat-label>
              <mat-select
                formControlName="subtipoEmpreendimento"
                required
                [disabled]="!subtiposEmpreendimento.length"
              >
                <mat-option>
                  <ngx-mat-select-search
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="searchSubtiposEmpreendimento"
                    name="searchSubtiposEmpreendimento"
                    placeholderLabel="Pesquise aqui"
                    noEntriesFoundLabel="Nenhum registro encontrado"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="
                    let s of subtiposEmpreendimento
                      | filter : searchSubtiposEmpreendimento : 'nome'
                  "
                  [value]="s"
                >
                  {{ s.nome }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="page-form-control quad">
              <mat-label>Tipo de oferta</mat-label>
              <mat-select formControlName="tipoOferta" required>
                <mat-option>Selecionar</mat-option>
                <mat-option
                  *ngFor="let e of empreendimentoTiposOferta"
                  [value]="e.value"
                  >{{ e.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="page-form-control quad">
              <mat-label>Estado de uso</mat-label>
              <mat-select formControlName="estadoUso" required>
                <mat-option>Selecionar</mat-option>
                <mat-option value="N">Novo</mat-option>
                <mat-option value="U">Usada</mat-option>
                <mat-option value="P">Na planta</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <mat-form-field class="page-form-control quad" required>
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="status">
                                <mat-option>Selecionar</mat-option>
                                <mat-option value="P">Pendente</mat-option>
                                <mat-option value="V">Vendido</mat-option>
                                <mat-option value="L">Locado</mat-option>
                            </mat-select>
                        </mat-form-field> -->
          </form>
        </mat-step>
        <mat-step
          [stepControl]="currencyFormGroup"
          errorMessage="Preencha todos os campos requiridos."
        >
          <form [formGroup]="currencyFormGroup" class="wrapper">
            <ng-template matStepLabel>Valores</ng-template>
            <mat-form-field class="page-form-control half">
              <mat-label>Valor condomínio</mat-label>
              <input matInput formControlName="valorCondominio" currencyMask />
            </mat-form-field>
            <mat-form-field class="page-form-control half">
              <mat-label>Valor</mat-label>
              <input matInput formControlName="valor" currencyMask required />
            </mat-form-field>
          </form>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Imagens</ng-template>
          <ngx-dropzone (change)="onSelect($event)" class="dropzone">
            <ngx-dropzone-label
              >Arraste e solte aqui suas imagens!</ngx-dropzone-label
            >
            <ngx-dropzone-image-preview
              ngProjectAs="ngx-dropzone-preview"
              *ngFor="let f of files"
              [removable]="true"
              (removed)="onRemove(f)"
              [file]="f"
            >
              <ngx-dropzone-label></ngx-dropzone-label>
            </ngx-dropzone-image-preview>
          </ngx-dropzone>
          <div>
            <button
              mat-raised-button
              color="primary"
              (click)="submit()"
              [disabled]="loadingService.active"
            >
              SALVAR
            </button>
          </div>
        </mat-step>
      </mat-vertical-stepper>
    </div>
  </div>
</section>
